import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { Observable } from "rxjs/internal/Observable";
import { ValidationMessage } from "../model/DataTextVal";
@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  numeroSubject$ = new BehaviorSubject([]);
  numero: Observable<ValidationMessage[]> = this.numeroSubject$.asObservable();
  updateNumero(newNumero: ValidationMessage[]) {

    this.numeroSubject$.next(newNumero)
  }
}